import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { SERVER_URL, BEEHOME_API_URL } from 'src/app/config';

@Injectable({
  providedIn: 'root'
})
export class LinksService {
  http = inject(HttpClient);

  public items: any = [];
  public categories: any = [];
  public favoriteLinks = [];
  public noItems = false;
  selectedLink: any;

  listLinks() {
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/link/list/category').pipe(map((data: any) => {
      this.items = data;
      if (this.items == null || this.items.length === 0) {
        this.noItems = true;
      } else {
        const links = [];
        for (const iterator of data) {
          if (iterator.linkTOs.length > 0) {
            links.push(iterator);
          }
        }
        if (links.length === 0) {
          this.noItems = true;
        } else {
          this.noItems = false;
        }
      }
      return data;
    }));
  }

  listCategories() {
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/link/list/allCategory').pipe(map((data: any) => {
      if (data != null) {
        this.categories = data;
      }
      return data;
    }));
  }

  saveLink(obj: any) {
    return this.http.post(SERVER_URL + BEEHOME_API_URL + '/link/', obj).pipe(map((data: any) => {
      return data;
    }));
  }

  editLink(obj: any) {
    return this.http.put(SERVER_URL + BEEHOME_API_URL + '/link/', obj).pipe(map((data: any) => {
      return data;
    }));
  }

  checkLink(link:string) {
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/link/existCorporateLink?url=' + encodeURIComponent(link)).pipe(map((data: any) => {
      return data;
    }));
  }

  deleteLink(id: any) {
    return this.http.delete(SERVER_URL + BEEHOME_API_URL + '/link/delete/' + id).pipe(map((data: any) => {
      return data;
    }));
  }

  listUserPersonalLinks() {
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/link/personal').pipe(map((data: any) => {
      return data;
    }));
  }

  savePersonalLink(obj: any) {
    return this.http.post(SERVER_URL + BEEHOME_API_URL + '/link/personal', obj).pipe(map((data: any) => {
      return data;
    }));
  }

  editPersonalLink(obj: any) {
    return this.http.put(SERVER_URL + BEEHOME_API_URL + '/link/personal', obj).pipe(map((data: any) => {
      return data;
    }));
  }

  deletePersonalLink(id: any) {
    return this.http.delete(SERVER_URL + BEEHOME_API_URL + '/link/personal/' + id).pipe(map((data: any) => {
      return data;
    }));
  }

  listLinkUserHistory() {
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/link/userHistory?first=0&last=5').pipe(map((data: any) => {
      this.favoriteLinks = data;
      return data;
    }));
  }

  saveLinkUserHistory(linkId) {
    return this.http.post(SERVER_URL + BEEHOME_API_URL + '/link/' + linkId + '/userHistory/insert', null).pipe(map((data: any) => {
      return data;
    }));
  }
}
